import * as React from "react";
import { useState } from "react";
import { Labeler } from "./components/Labeler";
import { PrintSheet, SheetLabel } from "./components/PrintSheet";
import { getRandomMeta } from "./meta";
import { Themes } from "./themes";

export const App: React.FC = () => {
    const [meta, setMeta] = useState(getRandomMeta());
    const [uppercase, setUppercase] = useState(true);
    const [theme, setTheme] = useState(Themes.Dark);
    const [labels, setLabels] = useState<SheetLabel[]>([]);
    const [artFileName, setArtFileName] = useState("");

    return (
            <main className="workspace">
                <section className="editor-panel" aria-labelledby="editor-title">
                    <div className="section-heading">
                        <div>
                            <p className="eyebrow">01 / MAKE A LABEL</p>
                            <h2 id="editor-title">Your artwork</h2>
                        </div>
                        <span className="status-note"><i /> LIVE PREVIEW</span>
                    </div>

                    <div className="preview-stage">
                        <Labeler
                            width={38}
                            height={54}
                            theme={theme}
                            fontSize={1.76}
                            headerHeight={5}
                            leftMargin={2}
                            lineHeight={2.12}
                            metaContainerHeight={11}
                            meta={meta}
                            uppercase={uppercase}
                            onAddToSheet={(label) => setLabels(previous => [
                                ...previous,
                                {
                                    ...label,
                                    id: `${Date.now()}-${Math.random().toString(36).slice(2)}`,
                                    copies: 1,
                                },
                            ])}
                        />
                    </div>

                    <div className="control-grid">
                        <div className="control-block metadata-controls">
                            <p className="eyebrow">LABEL DETAILS</p>
                            <label className="field">
                                <span>Album</span>
                                <input type="text" value={meta.album}
                                    onChange={({ currentTarget }) => setMeta({ ...meta, album: currentTarget.value })} />
                            </label>
                            <label className="field">
                                <span>Artist</span>
                                <input type="text" value={meta.artist}
                                    onChange={({ currentTarget }) => setMeta({ ...meta, artist: currentTarget.value })} />
                            </label>
                            <label className="field">
                                <span>Year</span>
                                <input type="text" value={meta.year}
                                    onChange={({ currentTarget }) => setMeta({ ...meta, year: currentTarget.value })} />
                            </label>
                        </div>
                        <div className="control-block appearance-controls">
                            <p className="eyebrow">FINISHING</p>
                            <label className="upload-control">
                                <span className="upload-title">Album art</span>
                                <span className="upload-hint">Square image, 500 px or wider</span>
                                <input type="file" accept="image/*" onChange={({ currentTarget }) => {
                                    const file = currentTarget.files?.[0];
                                    if (!file) return;
                                    setArtFileName(file.name);
                                    const reader = new FileReader();
                                    reader.onload = () => {
                                        if (typeof reader.result === "string") {
                                            setMeta(previous => ({ ...previous, artURL: reader.result as string }));
                                        }
                                    };
                                    reader.readAsDataURL(file);
                                }} />
                                <span className="file-button">Choose image</span>
                                <span className="file-name">{artFileName || "No image selected"}</span>
                            </label>
                            <fieldset className="choice-group">
                                <legend>Label theme</legend>
                                <label className="choice">
                                    <input name="theme" value="dark" type="radio" checked={theme === Themes.Dark}
                                        onChange={() => setTheme(Themes.Dark)} />
                                    <span className="choice-swatch swatch-dark" /> Dark
                                </label>
                                <label className="choice">
                                    <input name="theme" value="light" type="radio" checked={theme === Themes.Light}
                                        onChange={() => setTheme(Themes.Light)} />
                                    <span className="choice-swatch swatch-light" /> Light
                                </label>
                            </fieldset>
                            <label className="toggle-control">
                                <input type="checkbox" role="switch" checked={uppercase} onChange={() => setUppercase(!uppercase)} />
                                <span className="toggle-track" aria-hidden="true"><i /></span>
                                <span>Use uppercase text</span>
                            </label>
                        </div>
                    </div>
                </section>

                <section className="sheet-section" aria-label="A4 print sheet">
                    <PrintSheet labels={labels} setLabels={setLabels} />
                </section>
            </main>

    );
};
